// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__0VFGN","rows":"Monitor_rows__Htj9O","boxes":"Monitor_boxes__pbfag","attitude":"Monitor_attitude__py6SX"};